<template>
  <div class="quiz-form">
    <div class="quiz-form__inner">
      <div class="quiz-input" :class="{'has-error': fnameError}">
        <label for="fname">First name</label>
        <input
          v-model="fname"
          id="fname"
          type="text"
          placeholder="John"
          @input="validateFName"
          @blur="validateFName"
        >
        <div v-if="fnameError" class="quiz-input-error">
          {{ fnameError }}
        </div>
      </div>
      <div class="quiz-input" :class="{'has-error': lnameError}">
        <label for="lname">Last name</label>
        <input
          v-model="lname"
          id="lname"
          type="text"
          placeholder="Doe"
          @input="validateLName"
          @blur="validateLName"
        >
        <div v-if="lnameError" class="quiz-input-error">
          {{ lnameError }}
        </div>
      </div>
      <div class="quiz-input" :class="{'has-error': emailError}">
        <label for="email">E-mail</label>
        <input
          v-model="email"
          id="email"
          type="text"
          inputmode="email"
          placeholder="example@example.com"
          @input="validateEmail"
          @blur="validateEmail"
        >
        <div v-if="emailError" class="quiz-input-error">
          {{ emailError }}
        </div>
      </div>
      <InputGeo @change="location = $event" />
    </div>
    <div class="quiz-privacy">
      <input v-model="privacy" id="privacy" type="checkbox" hidden />
      <label for="privacy">
        I agree by electronic signature to: (1) receive marketing and other texts and messages from A1 SolarStore, directly or from third parties acting on its behalf, at the email address I entered above; (2) the <a href="https://a1solarstore.com/terms-and-conditions.html" target="_blank">Terms and Conditions</a>; and (3) the <a href="https://a1solarstore.com/privacy-policy.html" target="_blank">Privacy Policy</a>.
      </label>
    </div>
    <button
      class="quiz-btn"
      type="button"
      :disabled="!contactFilled"
      @click="$emit('next', {fname, lname, email, location})"
    >
      Do the last step!
    </button>
  </div>
</template>

<script>
import InputGeo from './InputGeo.vue'

export default {
  emits: ['next'],
  components: {
    InputGeo,
  },
  data() {
    return {
      fname: '',
      fnameError: null,
      lname: '',
      lnameError: null,
      email: '',
      emailError: null,
      location: null,
      privacy: false,
    }
  },
  computed: {
    contactFilled() {
      return this.privacy && this.fname.length && !this.fnameError && this.lname.length && !this.lnameError && this.email.length && !this.emailError && this.location
    },
  },
  methods: {
    validateFName() {
      const trimmed = this.fname.trim()
      if (!trimmed) this.fnameError = 'First name is required'
      else if (this.fname.length < 2) this.fnameError = 'First name must be at least 2 characters long'
      else this.fnameError = null
    },
    validateLName() {
      const trimmed = this.lname.trim()
      if (!trimmed) this.lnameError = 'Last name is required'
      else if (this.lname.length < 2) this.lnameError = 'Last name must be at least 2 characters long'
      else this.lnameError = null
    },
    validateEmail() {
      const trimmed = this.email.trim()
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!trimmed) this.emailError = 'E-mail is required'
      else if (!emailRegex.test(trimmed)) this.emailError = 'Enter a valid email'
      else this.emailError = null;
    },
  }
}
</script>